import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import Loading from "../Loading";
import { SubmitBtn } from "../Styles/InputStyles";
import Model from "../Model";
import { useFormik } from "formik";

const staticPropertyList = [
  { propId: 1, propName: "UPI" },
  { propId: 2, propName: "Credit Card" },
  { propId: 4, propName: "Net Banking" },
];

const CheckBox = ({ label, checked, onChange, disabled = false }) => (
  <label
    className={`relative flex items-center gap-3 border rounded-lg px-4 py-2 transition-all cursor-pointer border-gray-300 bg-white ${
      checked ? "bg-blue-100 border-blue-500" : ""
    } hover:border-blue-400 focus-within:border-blue-500`}
  >
    <input
      type="checkbox"
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      className="appearance-none w-5 h-5 rounded-full border border-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-300"
    />
    {checked && (
      <span className="absolute w-5 h-5 rounded-full flex justify-center items-center bg-blue-500 text-white">
        &#10004;
      </span>
    )}
    <p className="text-gray-500">{label}</p>
  </label>
);

const ConvinceFee = ({
  ConvinceFeeMutate,
  setConvinceFee,
  selectedData,
  ConvinceFeeLoading,
}) => {
  const [checkData, setCheckData] = useState(new Map());

  useEffect(() => {
    const initialCheckData = new Map();
    initialCheckData.set(1, selectedData?.upiEnabled === 0 ? false : true);
    initialCheckData.set(2, selectedData?.creditCardEnabled === 1);
    initialCheckData.set(4, selectedData?.netBankingEnabled === 1);
    setCheckData(initialCheckData);
  }, [selectedData]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      upiCharges: selectedData?.upiCharges ?? "0.00",
      creditCardCharges: selectedData?.creditCardCharges ?? "0.00",
      otherCharges: selectedData?.otherCharges ?? "0.00",
      upiEnabled: selectedData?.upiEnabled ?? 1,
      creditCardEnabled: selectedData?.creditCardEnabled ?? 0,
      netBankingEnabled: selectedData?.netBankingEnabled ?? 0,
    },
    onSubmit: (values) => {
      ConvinceFeeMutate({ values, clientId: selectedData.id });
    },
  });

  const handleCheckboxChange = (propId) => {
    setCheckData((prev) => {
      const newCheckData = new Map(prev);
      newCheckData.set(propId, !prev.get(propId));

      const fieldMap = {
        1: "upiEnabled",
        2: "creditCardEnabled",
        4: "netBankingEnabled",
      };

      formik.setFieldValue(fieldMap[propId], newCheckData.get(propId) ? 1 : 0);

      return newCheckData;
    });
  };

  const getFieldName = (propName) => {
    if (propName === "UPI") {
      return "upiCharges";
    } else if (propName === "Credit Card") {
      return "creditCardCharges";
    } else if (propName === "Net Banking") {
      return "otherCharges";
    } else {
      return "";
    }
  };
  

  return (
    <Model setOpenModel={setConvinceFee} width="w-11/12 max-w-lg">
      {ConvinceFeeLoading ? (
        <Loading />
      ) : (
        <form onSubmit={formik.handleSubmit}>
          <StyledWrapper>
            <StyledTitle>Payment Gateway Charges</StyledTitle>
            <div className="space-y-4">
              {staticPropertyList.map((item) => (
                <div key={item.propId}>
                  <CombineInputGroup>
                    <div className="flex-1">
                      <CheckBox
                        label={item.propName}
                        checked={checkData.get(item.propId) || false}
                        onChange={() => handleCheckboxChange(item.propId)}
                      />
                    </div>
                    <Input
                      key={item.propName}
                      type="number"
                      inputMode="decimal"
                      pattern="[0-9]*"
                      placeholder="0.00%"
                      name={getFieldName(item.propName)}
                      value={formik.values[getFieldName(item.propName)]}
                      onChange={formik.handleChange}
                    />
                  </CombineInputGroup>
                </div>
              ))}
            </div>
            <BtnWrapper>
              <SubmitBtn type="submit">Submit</SubmitBtn>
            </BtnWrapper>
          </StyledWrapper>
        </form>
      )}
    </Model>
  );
};

const CombineInputGroup = tw.div`flex items-center gap-4 w-full`;
const Input = tw.input`flex-1 truncate border border-gray-300 rounded pl-3 py-2 focus:ring-1 focus:ring-sky-600 focus:border-sky-600 focus:outline-none duration-200`;
const BtnWrapper = tw.div`w-full flex items-center justify-center space-x-10 mt-8`;
const StyledWrapper = tw.div`px-8 py-6 bg-white`;
const StyledTitle = tw.h2`text-lg md:text-xl lg:text-2xl text-gray-600 font-medium mb-6 text-center`;

export default ConvinceFee;
